import { FALLBACK_REGION } from '~/locale';
import { useRootLoaderData } from './useRootLoaderData'

export const useRegion = () => {
  const rootLoaderData = useRootLoaderData();

  return rootLoaderData?.userRegion ?? FALLBACK_REGION;
}
